exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".image__image{display:block;max-width:100%;border-image-width:0;margin-right:auto;margin-left:auto}.image__caption{margin-top:15px;font-size:13px;line-height:15px;font-style:italic;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./www/app/content/themes/rikssalsstiftelsen/sections/image/_image.scss
// module id = 24
// module chunks = 0